import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";


// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputAdornment from "@material-ui/core/InputAdornment";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import Icon from "@material-ui/core/Icon";

// @material-ui/icons
import Timeline from "@material-ui/icons/Timeline";
import Code from "@material-ui/icons/Code";
import Group from "@material-ui/icons/Group";
import Face from "@material-ui/icons/Face";
import Email from "@material-ui/icons/Email";
// import LockOutline from "@material-ui/icons/LockOutline";
import Check from "@material-ui/icons/Check";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import InfoArea from "components/InfoArea/InfoArea.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";

import styles from "assets/jss/material-dashboard-pro-react/views/registerPageStyle";

import { APP_CLIENT_ID, APP_CLIENT_SECRET } from "context/AuthContext";

import { authService } from "api/axios";

const useStyles = makeStyles(styles);

const REGISTER_URL = '/api/register';
const GET_CLIENT_TOKEN_URL = '/api/getClientToken?client_id=';

export default function RegisterPage() {
    const history = useHistory();
    const [clientToken, setClientToken] = useState("");
    const [formData, setFormData] = useState({
        firstName: "",
        lastName: "",
        email: "",
        password: "",
        birthDate: "",
        postalCode: "",
    });

    const [errorMsg, setErrorMsg] = useState("");
    const [checked, setChecked] = React.useState([]);


    const handleToggle = (value) => {
        const currentIndex = checked.indexOf(value);
        const newChecked = [...checked];

        if (currentIndex === -1) {
            newChecked.push(value);
        } else {
            newChecked.splice(currentIndex, 1);
        }
        setChecked(newChecked);
    };

    useEffect(() => {
        const controller = new AbortController();

        const getClientToken = async () => {
            try {
                const response = await authService.get(GET_CLIENT_TOKEN_URL + "8", {
                    headers: {
                        Authorization: "Basic " + btoa(APP_CLIENT_ID + ':' + APP_CLIENT_SECRET),
                    },
                });
                setClientToken(response.data.token);
            } catch (error) {
                console.error("Error fetching client token", error);
            }
        };

        getClientToken();

        return () => {
            controller.abort();
        };
    }, []);

    const handleSubmit = async (e) => {
        console.log("Handle Submite");
        e.preventDefault();

        const payload = {
            client_id: "8",
            email_address: formData.email,
            password: formData.password,
            first_name: formData.firstName,
            last_name: formData.firstName,
            birth_date: formData.birthDate,
            role: "f4d18b21-f17e-45c4-a7b1-7b2e6c1db92b",
            postal_code: formData.postalCode,
            registration_type: 0,
        };

        try {
            await authService.post(REGISTER_URL, payload, {
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${clientToken}`,
                },
            });
            // alert("Registration successful!");
            history.push("/login-page");
        } catch (error) {
            console.error("Registration error", error);
            if (!error?.response) {
                setErrorMsg("No Server Response");
            } else if (error.response?.status === 400) {
                setErrorMsg("Missing required fields or invalid input.");
            } else if (error.response?.status === 401) {
                setErrorMsg("Unauthorized access.");
            } else {
                setErrorMsg("Registration Failed, try again later.");
            }
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const classes = useStyles();
    return (
        <div className={classes.container}>
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={10}>
                    <Card className={classes.cardSignup}>
                        <h2 className={classes.cardTitle}>Register</h2>
                        <CardBody>
                            <GridContainer justify="center">
                                <GridItem xs={12} sm={12} md={5}>
                                    <InfoArea
                                        title="Marketing"
                                        description="We've created the marketing campaign of the website. It was a very interesting collaboration."
                                        icon={Timeline}
                                        iconColor="rose"
                                    />
                                    <InfoArea
                                        title="Fully Coded in HTML5"
                                        description="We've developed the website with HTML5 and CSS3. The client has access to the code using GitHub."
                                        icon={Code}
                                        iconColor="primary"
                                    />
                                    <InfoArea
                                        title="Built Audience"
                                        description="There is also a Fully Customizable CMS Admin Dashboard for this product."
                                        icon={Group}
                                        iconColor="info"
                                    />
                                </GridItem>
                                <GridItem xs={12} sm={8} md={5}>
                                    <div className={classes.center}>
                                        <Button justIcon round color="twitter">
                                            <i className="fab fa-twitter" />
                                        </Button>
                                        {` `}
                                        <Button justIcon round color="dribbble">
                                            <i className="fab fa-dribbble" />
                                        </Button>
                                        {` `}
                                        <Button justIcon round color="facebook">
                                            <i className="fab fa-facebook-f" />
                                        </Button>
                                        {` `}
                                        <h4 className={classes.socialTitle}>or be classical</h4>
                                    </div>
                                    <form className={classes.form} onSubmit={handleSubmit}>
                                        {errorMsg && <p style={{ color: "red" }}>{errorMsg}</p>}
                                        <CustomInput
                                            formControlProps={{
                                                fullWidth: true,
                                                className: classes.customFormControlClasses,
                                            }}
                                            inputProps={{
                                                name: "firstName",
                                                value: formData.firstName,
                                                onChange: handleChange,
                                                startAdornment: (
                                                    <InputAdornment
                                                        position="start"
                                                        className={classes.inputAdornment}
                                                    >
                                                        <Face className={classes.inputAdornmentIcon} />
                                                    </InputAdornment>
                                                ),
                                                placeholder: "First Name...",
                                            }}
                                        />
                                        <CustomInput
                                            formControlProps={{
                                                fullWidth: true,
                                                className: classes.customFormControlClasses,
                                            }}
                                            inputProps={{
                                                name: "lastName",
                                                value: formData.lastName,
                                                onChange: handleChange,
                                                startAdornment: (
                                                    <InputAdornment
                                                        position="start"
                                                        className={classes.inputAdornment}
                                                    >
                                                        <Face className={classes.inputAdornmentIcon} />
                                                    </InputAdornment>
                                                ),
                                                placeholder: "Last Name...",
                                            }}
                                        />
                                        <CustomInput
                                            formControlProps={{
                                                fullWidth: true,
                                                className: classes.customFormControlClasses,
                                            }}
                                            inputProps={{
                                                name: "email",
                                                value: formData.email,
                                                onChange: handleChange,
                                                startAdornment: (
                                                    <InputAdornment
                                                        position="start"
                                                        className={classes.inputAdornment}
                                                    >
                                                        <Email className={classes.inputAdornmentIcon} />
                                                    </InputAdornment>
                                                ),
                                                placeholder: "Email...",
                                            }}
                                        />
                                        <CustomInput
                                            formControlProps={{
                                                fullWidth: true,
                                                className: classes.customFormControlClasses,
                                            }}
                                            inputProps={{
                                                name: "password",
                                                value: formData.password,
                                                onChange: handleChange,
                                                startAdornment: (
                                                    <InputAdornment
                                                        position="start"
                                                        className={classes.inputAdornment}
                                                    >
                                                        <Icon className={classes.inputAdornmentIcon}>
                                                            lock_outline
                                                        </Icon>
                                                    </InputAdornment>
                                                ),
                                                placeholder: "Password...",
                                            }}
                                        />
                                        <CustomInput
                                            formControlProps={{
                                                fullWidth: true,
                                                className: classes.customFormControlClasses,
                                            }}
                                            inputProps={{
                                                name: "birthDate",
                                                value: formData.birthDate,
                                                onChange: handleChange,
                                                placeholder: "Birth Date (YYYY-MM-DD)...",
                                            }}
                                        />
                                        <CustomInput
                                            formControlProps={{
                                                fullWidth: true,
                                                className: classes.customFormControlClasses,
                                            }}
                                            inputProps={{
                                                name: "postalCode",
                                                value: formData.postalCode,
                                                onChange: handleChange,
                                                placeholder: "Postal Code...",
                                            }}
                                        />
                                        <FormControlLabel
                                            classes={{
                                                root: classes.checkboxLabelControl,
                                                label: classes.checkboxLabel,
                                            }}
                                            control={
                                                <Checkbox
                                                    tabIndex={-1}
                                                    onClick={() => handleToggle(1)}
                                                    checkedIcon={
                                                        <Check className={classes.checkedIcon} />
                                                    }
                                                    icon={<Check className={classes.uncheckedIcon} />}
                                                    classes={{
                                                        checked: classes.checked,
                                                        root: classes.checkRoot,
                                                    }}
                                                />
                                            }
                                            label={
                                                <span>
                                                    I agree to the{" "}
                                                    <a href="#pablo">terms and conditions</a>.
                                                </span>
                                            }
                                        />
                                        <div className={classes.center}>
                                            <Button round color="primary" type="submit">
                                                Get started
                                            </Button>
                                        </div>
                                    </form>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}
